export default {
  weAreSis: {
    title: ['SomosConsultoría', 'Empresarial'],
    description:
      'La SIS Consultoría es una empresa proveedora de servicios y soluciones integradas de sistemas y consultoría de negocios, en línea con las principales estrategias corporativas, con un equipo  altamente cualificado. Nuestra experiencia y compromiso reflejan el alto nivel de satisfacción y reconocimiento de nuestros clientes.',
    button: 'CONOZCA NUESTRA HISTORIA',
  },
}
